
import Service from '@/services/ask-operation/operation-service'
import { app } from '@/main'
const source = 'pdrsDataTable'


function daSospendere () {
  
  const eventBus = app.config.globalProperties.$eventBus;
  const http = app.config.globalProperties.$http;
  const service = new Service(http, eventBus)
  const keys = Object.keys(this.filtered.items).filter((s) => s == source)
  if(keys.length > 0){
    eventBus.emit('data-global-loading')
    const items = this.filtered.items[source]
    service.createMultiPreSuspensionOrReactivation(items, 'pdrs', 'sospensioni')
    .finally(()=>{
      eventBus.emit('data-global-loaded')
    })

  } 
}

export default {
  'bindTo': 'this',
  'method': daSospendere,
}
